import React, { PropsWithChildren } from 'react';

import { Field, Form as FinalForm } from 'react-final-form';
import { WrappedComponentProps } from 'react-intl';

import FieldGroup from 'components/PortalFormFields/FieldGroup';
import { ButtonComponent } from 'theme/components/Button';
import { withIntl } from 'utils/intl';
import { combineValidators, maxLength, required } from 'utils/validators';

import { StyledTextArea } from './styles';
import { StyledHeading } from '../../styles';

const TEXT_AREA_MAX_LENGTH = 500;

type FormProps = {
  onSubmit: (values: any) => void;
} & WrappedComponentProps &
  PropsWithChildren;

const Form = ({ onSubmit, intl: { formatMessage }, children }: FormProps) => {
  const t = (id: string) =>
    formatMessage({ id: `pages.inquiryDetails.dashboard.closeInquiry.archiveInquiry.${id}` });

  return (
    <>
      <FinalForm
        onSubmit={onSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <StyledHeading>{t('title')}</StyledHeading>

            <Field
              name="archivingReason"
              data-testid="Rejection-Reason"
              validate={combineValidators(
                required(formatMessage({ id: 'errors.required' })),
                maxLength(
                  TEXT_AREA_MAX_LENGTH,
                  formatMessage(
                    { id: 'errors.maxLengthTextCharacters' },
                    { number: TEXT_AREA_MAX_LENGTH },
                  ),
                ),
              )}
            >
              {({ input, meta }) => (
                <FieldGroup
                  error={meta.touched && meta.error ? meta.error : null}
                  label={t('description')}
                >
                  <StyledTextArea placeholder={t('placeholder')} {...input} {...meta} />
                </FieldGroup>
              )}
            </Field>

            <ButtonComponent mt={4} type="submit" testId="archiveInquiryButton">
              {t('archiveInquiryBtn')}
            </ButtonComponent>
            {children}
          </form>
        )}
      />
    </>
  );
};

export default withIntl(Form);
